<template>
    <MainContentSearchable title="Listado de indumentarias" id="indumentarias" v-model="filters" :meta="loading ? {} : indumentarias.meta" @updated="debouncedGetIndumentarias">
        <template v-slot:header>
            <div class="mb-3">
                <router-link :to="{ name: 'back.bases.indumentarias.crear', params: { lista_id: lista_id } }" class="btn btn-primary mr-2" target="blank">Nueva indumentaria</router-link>
                <router-link :to="{ name: 'back.bases.indumentarias.inventario', params: { lista_id: lista_id } }" class="btn btn-primary" target="blank">Inventario</router-link>
            </div>
        </template>
        <template v-slot:extra-options>
            <div class="col-12 col-lg-9" v-if="tallas">
                <div class="input-group-sm my-3">
                    <select class="custom-select w-auto" v-model="filters.talla" @change="debouncedGetIndumentarias()">
                        <option value="">Filtrar talla</option>
                        <template v-for="talla in tallas">
                            <option :key="talla.id" :value="talla.nombre">{{ talla.nombre }}</option>
                        </template>
                    </select>
                </div>
            </div>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <div :class="['table', { 'expanded': indumentarias.data.length <= 3 }]">
                    <b-table hover :items="indumentarias.data" :fields="fields" id="indumentarias-table">
                        <template #cell(tallas)="{ item }">
                            <template v-for="talla in item.tallasSelect">
                                {{ talla.nombre }}
                            </template>
                        </template>
                        <template #cell(precio)="{ item }">
                            <span v-if="item.incluida"><del>{{ item.precio | formatear_precio }}</del> (0 €)</span>
                            <span v-else>{{ item.precio | formatear_precio }}</span>
                        </template>
                        <template #cell(imagen)="{ item }">
                            <img :src="item.imagen" style="width: 75px;"/>
                        </template>
                        <template #cell(incluir)="{ item }">
                            <span v-if="item.incluida" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(cantidad_incluida)="{ item }">
                            <span v-if="item.incluida" class="mr-2">{{ item.cantidad_incluida }}</span>
                        </template>
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent
                                :lastIndex="indumentarias.data.length > 3 && index >= indumentarias.data.length - 3"
                                v-bind:options="[
                                    { to: { name: 'back.bases.indumentarias.show', params: { lista_id: lista_id, indumentaria_id: item.id } }, label: 'Detalle'},
                                    { to: { name: 'back.bases.indumentarias.update', params: { lista_id: lista_id, indumentaria_id: item.id } }, label: 'Editar'},
                                    { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'},
                                ]"
                            />
                            <BorrarModalComponent
                                :name="'borrar-' + item.id"
                                :title="'Borrar imagen de la indumentaria ' + item.nombre"
                                confirmButton="¿Está segur@ de borrar esta indumentaria?"
                                v-on:close="() => closeModal()"
                                v-on:confirm="() => borrar(item.id)"
                            />
                        </template>
                    </b-table>
                </div>
            </div>
            <LoaderComponent v-else/>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

    export default {
        data() {
            return {
                indumentarias: { data: [], meta: { current_page: 1 } },
                loading: false,
                tallas: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    talla: ''
                },
                fields: [
                    { key: "id", label: "ID"},
                    { key: "nombre", label: "Nombre" },
                    { key: "tallas", label: "Tallas", class: 'text-center' },
                    { key: "precio", label: "Precio", class: 'text-center' },
                    { key: 'imagen', label: "Imagen", class: 'text-center' },
                    { key: 'incluir', label: "Incluida", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ],
            }
        },
        created() {
            this.getIndumentarias();
            this.getTallas();
            this.debouncedGetIndumentarias = _.debounce(this.getIndumentarias, 500);
        },
        methods: {
            getIndumentarias() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    filters: this.filters
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.index'), params).then(res => {
                    this.indumentarias = res.data;
                }).finally(() => this.loading = false);
            },
            getTallas() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    filters: {}
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.get-tallas'), params).then(res => {
                    this.tallas = res.data.tallas;
                }).finally(() => this.loading = false);
            },
            borrar(indumentaria_id) {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    indumentaria_id: indumentaria_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.delete'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getIndumentarias();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            } 
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, BorrarModalComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>